<div class="container-fluid px-0 m-0" style="background-image: url('assets/images/Vector.png'); min-height: 100vh;background-color: rgba(35, 113, 211, 0.03);">
    <div class="custom-headingTop bg-white d-flex">
        <div class="h6 font-weight-bold pt-1 sm-22">
            <!-- <i class="fas fa-mobile-alt pr-2 pl-0 primary-text"></i> -->
            <svg  class="mr-2 pt-1"  width="22" height="25" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.75 15.5L12.75 12.5V9C12.75 7.66667 10.2167 6.24067 9.25 5.5" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M10.5367 9.86266L8.10473 7.91333C7.88525 7.69385 7.56535 7.60813 7.26554 7.68847C6.96572 7.7688 6.73154 8.00299 6.65121 8.3028C6.57087 8.60262 6.65659 8.92252 6.87607 9.142L9.23207 11.8V13.4667C9.23207 14.254 10.3567 15.4967 10.3567 15.4967" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.24333 13.616C9.18447 14.12 8.75744 14.5 8.25 14.5H2.25C1.69772 14.5 1.25 14.0523 1.25 13.5V1.5C1.25 0.947715 1.69772 0.5 2.25 0.5H8.25C8.80228 0.5 9.25 0.947715 9.25 1.5V8.83333" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.25001 9.49996C4.33131 9.49876 3.53158 8.87182 3.31109 7.97997C3.0906 7.08812 3.50606 6.16075 4.31836 5.73159C5.13066 5.30243 6.13087 5.48187 6.74334 6.16663" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3 2C3.13807 2 3.25 2.11193 3.25 2.25C3.25 2.38807 3.13807 2.5 3 2.5C2.86193 2.5 2.75 2.38807 2.75 2.25C2.75 2.11193 2.86193 2 3 2" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M7.5 12.5C7.63807 12.5 7.75 12.6119 7.75 12.75C7.75 12.8881 7.63807 13 7.5 13C7.36193 13 7.25 12.8881 7.25 12.75C7.25 12.6119 7.36193 12.5 7.5 12.5" stroke="#2371D3" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                
            Request money
        </div>
        <div class="request-money-timeline" style="margin-left: 20%;">
            <ul class="timeline m-0 pt-1 px-5" id="timeline">
                <li class="li" [ngClass]="{'complete': requestMoneyervice.isRequestChecked}">
                    <div class="status pl-0 px-3">
                        <p class="sm-12 m-neg color-royalblue">Request</p>
                    </div>
                </li>
                <li class="li" [ngClass]="{'complete': requestMoneyervice.isFormChecked}">
                    <div class="status pl-0 px-3">
                        <p class="sm-12 m-neg color-royalblue">From</p>
                    </div>
                </li>
                <li class="li" [ngClass]="{'complete': requestMoneyervice.isConfirmChecked}">
                    <div class="status pl-0 px-3">
                        <p class="sm-12 m-neg color-royalblue">Confirm</p>
                    </div>
                </li>
                <li class="li" [ngClass]="{'complete': requestMoneyervice.isCompleteChecked}">
                    <div class="status pl-0 px-3 border-0">
                        <p class="sm-12 m-neg color-royalblue border-0">Complete</p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
<router-outlet></router-outlet>
</div>

